import { render, staticRenderFns } from "./UsersBasicsYAvan.vue?vue&type=template&id=138adad7"
import script from "./UsersBasicsYAvan.vue?vue&type=script&lang=js"
export * from "./UsersBasicsYAvan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports